module.exports = __webpack_public_path__ + "static/media/Character7.3fe768cb.png";